import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Set up a Sprinklr Connection")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_5 = {
  key: 1,
  class: "col-12 mb-3"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " To install the app you need to connect to your Sprinklr account. Please select your Sprinklr environment and start the authentication process ", -1)
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "modal show",
  tabindex: "-1",
  style: {"display":"block"}
}
const _hoisted_14 = { class: "modal-dialog" }
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Remove app", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this app?")
], -1)
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.authorizeReturn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Please wait..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.environments, (env, envIdx) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: envIdx,
                  class: _normalizeClass(['btn', _ctx.selectedEnvironment === env ? 'btn-lightdark' : 'btn-outline-lightdark', 'me-2', 'mb-2']),
                  onClick: _withModifiers(($event: any) => (_ctx.selectedEnvironment = env), ["stop","prevent"])
                }, _toDisplayString(env), 11, _hoisted_8))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.selectedEnvironment)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSprinklr()))
                  }, " Start authentication on " + _toDisplayString(_ctx.selectedEnvironment), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeApp && _ctx.removeApp(...args)))
              }, _hoisted_12)
            ])
          ]))
    ]),
    (_ctx.removeModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeModal = false))
                })
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeModal = false))
                }, " Close "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeAppConfirm && _ctx.removeAppConfirm(...args)))
                }, _hoisted_22)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}